__turbopack_context__.v({
  "avatar": "Avatar-module__ofZF0G__avatar",
  "away": "Avatar-module__ofZF0G__away",
  "blurred": "Avatar-module__ofZF0G__blurred",
  "busy": "Avatar-module__ofZF0G__busy",
  "circle": "Avatar-module__ofZF0G__circle",
  "fallback": "Avatar-module__ofZF0G__fallback",
  "group": "Avatar-module__ofZF0G__group",
  "image": "Avatar-module__ofZF0G__image",
  "lg": "Avatar-module__ofZF0G__lg",
  "md": "Avatar-module__ofZF0G__md",
  "offline": "Avatar-module__ofZF0G__offline",
  "online": "Avatar-module__ofZF0G__online",
  "remaining": "Avatar-module__ofZF0G__remaining",
  "rounded": "Avatar-module__ofZF0G__rounded",
  "sm": "Avatar-module__ofZF0G__sm",
  "square": "Avatar-module__ofZF0G__square",
  "status": "Avatar-module__ofZF0G__status",
  "xl": "Avatar-module__ofZF0G__xl",
  "xs": "Avatar-module__ofZF0G__xs",
  "xxl": "Avatar-module__ofZF0G__xxl",
});
